import { createAction, createAsyncAction } from 'typesafe-actions';
import { IpWhitelistRecord, IpWhitelistRecordUpdateDto } from '@rootCommon/types/fhq';
import { IdType } from '@rootCommon/types/common';

export const fetchIpWhitelistRecords = createAsyncAction(
  'FETCH_IP_WHITELIST_RECORDS_REQUEST',
  'FETCH_IP_WHITELIST_RECORDS_SUCCESS',
  'FETCH_IP_WHITELIST_RECORDS_FAILURE',
)
<IdType, IpWhitelistRecord[], Error>();

export const changeIpWhitelistRecord = createAsyncAction(
  'CHANGE_IP_WHITELIST_RECORD_REQUEST',
  'CHANGE_IP_WHITELIST_RECORD_SUCCESS',
  'CHANGE_IP_WHITELIST_RECORD_FAILURE',
)
<{ siteId: IdType; data: IpWhitelistRecord[] | IpWhitelistRecordUpdateDto[] }, IpWhitelistRecord[], Error>();

export const setIpWhitelistRecordsIsLoading = createAction('SET_IP_WHITELIST_IS_LOADING')<undefined>();
